import { Directive, Input, EventEmitter, Output, OnInit, AfterViewInit, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomButtonComponent } from '../custom-button/custom-button.component';
import { CustomCheckboxComponent } from '../custom-checkbox/custom-checkbox.component';
import { CustomDropDownListComponent } from '../custom-drop-down-list/custom-drop-down-list.component';
import { CustomInputComponent } from '../custom-input/custom-input.component';

import { CustomSwitchComponent } from '../custom-switch/custom-switch.component';
import { FieldConfig } from './dynamicForm.interface';
import { FieldTypeEnum } from 'src/app/core/dynamic-form/dynamicForm.interface';
import { CustomTextAreaComponent } from '../custom-text-area/custom-text-area.component';
import { CustomDividerComponent } from '../custom-divider/custom-divider.component';
import { CustomDatePickerComponent } from '../custom-date-picker/custom-date-picker.component';
import { CustomTitleComponent } from '../custom-title/custom-title.component';

import { CustomFileUploaderComponent } from '../custom-file-uploader/custom-file-uploader.component';
import { CustomRadioButtonComponent } from '../custom-radio-button/custom-radio-button.component';
import { CustomItemSelectorComponent } from '../custom-item-selector/custom-item-selector.component';
import { DropdownListDataSourceEvent } from '../custom-drop-down-list/customDropDownList.interface';

const componentMapper: Record<FieldTypeEnum, object> = {
  select: CustomDropDownListComponent,
  button: CustomButtonComponent,
  input: CustomInputComponent,
  numberInput: CustomInputComponent,
  password: CustomInputComponent,
  switch: CustomSwitchComponent,
  checkbox: CustomCheckboxComponent,
  upload: CustomFileUploaderComponent,
  //fake: Object,
  //separator: Object,
  date: CustomDatePickerComponent,
  time: CustomDatePickerComponent,
  datetime: CustomDatePickerComponent,
  //buttonGroup: Object,
  radiobutton: CustomRadioButtonComponent,
  textarea: CustomTextAreaComponent,
  divider: CustomDividerComponent,
  title: CustomTitleComponent,
  color: CustomInputComponent,
  file: CustomInputComponent,
  embed: Object,
  itemSelect: CustomItemSelectorComponent,
  autoComplete: CustomDropDownListComponent
  /*
    date: DateComponent,
    radiobutton: RadiobuttonComponent,
    checkbox: CheckboxComponent,
    toggle: ToggleComponent,
    fake: FakeComponent,
    buttonMenu: ButtonMenuComponent,
    label: LabelComponent,
    separator: SeparatorComponent,
    textarea: TextareaComponent,
    groupTitle: GroupTitleComponent,
    typeahead: TypeahedComponent,
    datePicker: DatePickerComponent,
    select2: Select2Component,
   */
};
@Directive({
  selector: '[appDynamicField]',
  standalone: false
})
export class DynamicFieldDirective implements OnInit, AfterViewInit {
  @Input() field!: FieldConfig;
  @Input() group!: FormGroup;
  @Input() dateTipe!: string;
  @Input() getDataSource: EventEmitter<string> = new EventEmitter<string>();//dropdown
  @Input() updateDataSource: EventEmitter<string> = new EventEmitter<string>();//dropdown

  // creano un event quando cambia lo stato di qualcosa
  @Output() onFieldChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNoSubmitClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onButtonMenuClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onInputChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectChangeEvent: EventEmitter<any> = new EventEmitter<any>(); //dropdown
  @Output() onSwitchChange: EventEmitter<any> = new EventEmitter<any>();      // switch
  @Output() onCheckBoxChange: EventEmitter<any> = new EventEmitter<any>();    // checkbox
  @Output() onDateTimeChange: EventEmitter<any> = new EventEmitter<any>();    // dateTime
  @Output() onRadioChange: EventEmitter<any> = new EventEmitter<any>(); //radio
  @Output() valueChangedEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onKeyUp: EventEmitter<any> = new EventEmitter<any>();
  
  @Output() sendDataSourceDropdown: EventEmitter<DropdownListDataSourceEvent> = new EventEmitter<DropdownListDataSourceEvent>();//dropdown
  @Output() dropdownDataSourceReady: EventEmitter<string> = new EventEmitter<string>();//dropdown

  componentRef: any;


  constructor(
    private container: ViewContainerRef,
  ) { }


  ngOnInit() {


    this.componentRef = this.container.createComponent((componentMapper as any)[this.field.type]);

    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
    this.componentRef.instance.options = this.field.options;


    if (this.componentRef.instance instanceof CustomButtonComponent) {
      const button: CustomButtonComponent = this.componentRef.instance;
      button.onClickEvent.subscribe((event: any) => {
        this.onNoSubmitClick.emit(event);
      });
    }
    // if (this.componentRef.instance instanceof ButtonMenuComponent) {
    //   const buttonMenu: ButtonMenuComponent = this.componentRef.instance;
    //   buttonMenu.onMenuClickEvent.subscribe((event: any) => {
    //     this.onButtonMenuClick.emit(event);
    //   });
    // }
    if (this.componentRef.instance instanceof CustomInputComponent) {
      const inputCompnent: CustomInputComponent = this.componentRef.instance;
      inputCompnent.changeValue.subscribe((event: any) => {
        this.onInputChange.emit(event);
      });
      inputCompnent.keyUp.subscribe((event: any) => {
        this.onKeyUp.emit(event);
      });
    }


    if (this.componentRef.instance instanceof CustomTextAreaComponent) {
      const textAreaCompnent: CustomTextAreaComponent = this.componentRef.instance;
      textAreaCompnent.changeValue.subscribe((event: any) => {
        this.onInputChange.emit(event);
      });
    }

    if (this.componentRef.instance instanceof CustomDropDownListComponent) {
      const multi: CustomDropDownListComponent = this.componentRef.instance;
      multi.change.subscribe((event: any) => {
        this.onSelectChangeEvent.emit(event);
      });
      
      multi.dataSourceReady.subscribe((event: string) => {
        this.dropdownDataSourceReady.emit(event);
      });

      multi.sendDataSource.subscribe((event: DropdownListDataSourceEvent) => {
        if (event.field == this.field.name) {

          this.sendDataSourceDropdown.emit(event);
        }
      });

      this.getDataSource.subscribe((event: string) => {
        multi.getDataSource.emit(event);
      });

      this.updateDataSource.subscribe((event: string) => {
        multi.updateDataSource.emit(event);
      });
    }

    if (this.componentRef.instance instanceof CustomRadioButtonComponent) {
      const radio: CustomRadioButtonComponent = this.componentRef.instance;
      radio.change.subscribe((event: any) => {
        this.valueChangedEvent.emit(event);
      });
    }

    if (this.componentRef.instance instanceof CustomItemSelectorComponent) {
      const itemSelect: CustomItemSelectorComponent = this.componentRef.instance;
      itemSelect.onChanges.subscribe((event: any) => {
        this.onFieldChange.emit(event);
      });
    }


    //custom file upload input

    if (this.componentRef.instance instanceof CustomFileUploaderComponent) {
      const fileUp: CustomFileUploaderComponent = this.componentRef.instance;
      fileUp.onValueChangedEvent.subscribe((event: any) => {
        this.valueChangedEvent.emit(event);
      });
    }


    /* custom switch instance */
    if (this.componentRef.instance instanceof CustomSwitchComponent) {
      const switchComponent: CustomSwitchComponent = this.componentRef.instance;
      switchComponent.changedValue.subscribe((event: any) => {
        this.onSwitchChange.emit(event);
      });
    }

    /* custom checkbox instance */
    if (this.componentRef.instance instanceof CustomCheckboxComponent) {
      const checkboxComponent: CustomCheckboxComponent = this.componentRef.instance;
      checkboxComponent.changedValue.subscribe((event: any) => {
        this.onCheckBoxChange.emit(event);
      });
    }

    /* custom dateTime instance */
    if (this.componentRef.instance instanceof CustomDatePickerComponent) {
      const datePickerCompnent: CustomDatePickerComponent = this.componentRef.instance;
      datePickerCompnent.changeValue.subscribe((event: any) => {
        this.onDateTimeChange.emit(event);
      })
    }

    // if (this.componentRef.instance instanceof DatePickerComponent) {
    //   const datePickerCompnent: DatePickerComponent = this.componentRef.instance;
    //   datePickerCompnent.changeValue.subscribe((event: any) => {
    //     this.onInputChange.emit(event);
    //   });
    // }
    if (this.group.get(this.field.name) !== null) {
      this.group.get(this.field.name)!.valueChanges.subscribe(val => {
        if (this.field.value != val) {
          this.field.value = val;
          this.onFieldChange.emit({ field: this.field.name, value: val });
        }
      });
    }
  }

  ngAfterViewInit() {


  }

}
